export default __webpack_public_path__ + "static/media/res-next.47b565f0.svg";